import { Response } from "interface";
import { authToken, serverAddress } from "./storage";
import ENV from "env.json";
export const SERVER = serverAddress.get() ? serverAddress.get() : ENV.api;

function generateHeader(object: any = {}, goastMode = false): any {
  const header: { [k: string]: any } = {};
  if (authToken.get() && !goastMode) {
    header["Authorization"] = "jwt " + authToken.get()?.access;
  }
  for (const key of Object.keys(object)) {
    header[key] = object[key];
  }
  return header;
}
export function del<R>(url: string): Promise<Response<R>> {
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(SERVER + url, {
      method: "DELETE",
      headers: generateHeader({ "Content-Type": "application/json" }),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

// post request
export function post<R>(
  url: string,
  body: any,
  goastMode = false
): Promise<Response<R>> {
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(SERVER + url, {
      method: "POST",
      headers: generateHeader(
        { "Content-Type": "application/json" },
        goastMode
      ),
      body: JSON.stringify(body),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

// form request (not post, like html form submit)
export function form<R>(url: string, body: any): Promise<Response<R>> {
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(SERVER + url, {
      method: "POST",
      body: body,
      headers: generateHeader(),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

// put request
export function put<R>(url: string, body: any): Promise<Response<R>> {
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(SERVER + url, {
      method: "PUT",
      body: JSON.stringify(body),
      headers: generateHeader({ "Content-Type": "application/json" }),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

// patch request
export function patch<R>(url: string, body: any): Promise<Response<R>> {
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(SERVER + url, {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: generateHeader({ "Content-Type": "application/json" }),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

// get request
export function get<R>(
  url: string,
  params: { [k: string]: any } = {}
): Promise<Response<R>> {
  const generatedUrl = new URL(SERVER + url);
  // add query parameters like filters or pagination parameters
  Object.keys(params).forEach((key) => {
    generatedUrl.searchParams.append(key, params[key]);
  });
  let status: number;
  return new Promise((resolve, reject) => {
    fetch(generatedUrl.href, {
      method: "GET",
      headers: generateHeader({ "Content-Type": "application/json" }),
    })
      .then(function (response) {
        status = response.status;
        return response.json();
      })
      .then(function (data) {
        if (responseValidator(status)) resolve({ data, status });
        else reject({ data, status });
      })
      .catch((/* err */) => {
        reject({ data: null, status });
      });
  });
}

function responseValidator(status: number): boolean {
  return status >= 200 && status < 300;
}

export function upload<R>(
  URL: string,
  formData: any,
  auth = true,
  onProgress?: (progress: number) => void
): Promise<Response<R>> {
  // let abort: any;
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    // abort = request.abort;
    request.upload.addEventListener("progress", function (e) {
      if (onProgress) onProgress(e.loaded);
    });
    request.open("post", SERVER + URL);
    request.onload = function () {
      if (request.readyState == XMLHttpRequest.DONE)
        resolve({
          status: request.status,
          data: JSON.parse(request.responseText),
        });
      else reject({ status: request.status, data: null });
    };
    request.onerror = () => reject({ status: request.status, data: null });
    if (auth)
      request.setRequestHeader(
        "Authorization",
        "jwt " + authToken.get()?.access
      );
    request.timeout = 45000;
    request.send(formData);
  });
  // return { promise, abort };
}
